import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const BalanceColor = ({
  code, label, index, link,
}) => {
  const ref = useRef(null);
  const handleClick = (e) => {
    e.preventDefault();

    if (link && global.Turbo) {
      global.Turbo.visit(link);
    }
  };

  return (
    <div
      ref={ref}
      className={classnames('BalanceColor mb-4', `BalanceColor--${code}`)}
      onClick={handleClick}
    >
      <div className="BalanceColor__content">
        <div className="BalanceColor__bg" />
        <h5 className="BalanceColor__caption">
          <span className="BalanceColor__captionIndex d-none">
            {index}
            .o
          </span>
          <span className="BalanceColor__captionLabel">{label}</span>
        </h5>
      </div>
    </div>
  );
};

BalanceColor.propTypes = {
  label: PropTypes.string.isRequired,
  code: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
};

export default BalanceColor;
